
import React, {Component} from 'react'
import getWeb3 from './utils/getWeb3'
import Web3 from 'web3'
import _ from 'lodash';
import variablestore from './variablestore'

import {Link} from "react-router"
import NavLink from './NavLink'

import cross from '../img/cross.jpg'
import tick from '../img/tick.jpg'
const blockies = require('ethereum-blockies-png')
const gasLimit = 100000
class RegisterEscrow extends Component {
	
		constructor(props){
			super(props)

			// eslint-disable-next-line no-undef
			var ETH_CLIENT = new Web3(web3.currentProvider)
			var EscrowMyEtherEntityDB_ABI = variablestore.EscrowMyEtherEntityDB_ABI
			var EscrowMyEtherEntityDB_address = variablestore.EscrowMyEtherEntityDB_address
			var myetherescrowABI = variablestore.myetherescrowABI
			var myetherescrowAddress = variablestore.myetherescrowAddress
			
			this.state = {

				ETH_CLIENT: ETH_CLIENT,
				mee: ETH_CLIENT.eth.contract(myetherescrowABI).at(myetherescrowAddress),
				entitydb: ETH_CLIENT.eth.contract(EscrowMyEtherEntityDB_ABI).at(EscrowMyEtherEntityDB_address),
				accounts: ETH_CLIENT.eth.accounts,
				fromAddress: "",
        escrowFee: 0,
				
				addressBalance: 0,
				balance: 0,
				withdrawText: "Withdraw Funds",
        escrowName: "",
				escrowInfo: "",
				callback: "",
			
				popup: false,
				addressBlockie: "",
				feeInfo: ""
			}



			this.handleFromAddressInput = this.handleFromAddressInput.bind(this);
			this.generateTransaction = this.generateTransaction.bind(this);
			this.handleWithdraw = this.handleWithdraw.bind(this);
      this.handleNameInput = this.handleNameInput.bind(this);
      this.handleInfoInput = this.handleInfoInput.bind(this);
    
      this.handleFeeInput = this.handleFeeInput.bind(this);
			this.setFee = this.setFee.bind(this);
			

			this.getAddressBalance = this.getAddressBalance.bind(this);
			this.getContractBalance = this.getContractBalance.bind(this);
			this.getEscrowFullInfo = this.getEscrowFullInfo.bind(this);
			
			this.resetButtonText = this.resetButtonText.bind(this);
			this.closePopup = this.closePopup.bind(this);
			this.clearState = this.clearState.bind(this);
		}
		closePopup() {
			this.setState({				
				popup: false			
			});

		}
		handleNotesInput(e) {
			this.setState({				
				note: e.target.value,			
			});

		}
		clearState() {
			this.resetButtonText()
			this.setState({				
				popup: false,
				addressBalance: 0,
				balance: 0,
				tableRows: [],
				escrowName: "",
				escrowInfo: "",
				escrowFee: 0,
				fromAddress: "",
				addressBlockie: ""
			});

		}
    handleFeeInput(e) {
			if (!isNaN(e.target.value) && e.target.value > 0 && e.target.value <= 10)
			{
						this.setState({fee: e.target.value,
						feeInfo: <p className="small"><font className="green">You will charge {e.target.value}% fee per transaction.</font></p>});		
				
			}
			else
				{
					this.setState({fee: e.target.value,
						feeInfo: <p className="small"><font className="red">Invalid input. Fee must be between 0-10%.</font></p>});
				}
		}
		
		handleFromAddressInput(e) {
			if (!this.state.ETH_CLIENT.isAddress(e.target.value))
				{
					this.clearState()
					return false
				}
			var blockieData = blockies.createDataURL({seed: e.target.value})
			this.setState({fromAddress: e.target.value,
			addressBlockie: blockieData});
			this.getAddressBalance(e.target.value)
			this.getContractBalance(e.target.value)
			this.getEscrowFullInfo(e.target.value)
			
			this.resetButtonText()	
		}


		getAddressBalance(e){
			this.state.mee.CheckBalance(e, function(error, result){
				if(!error)
					{
					this.setState({balance: +(parseInt(result)/(10**18)).toFixed(6)});
					}
				else
					console.log(error)
		
			}.bind(this))

		}

		getContractBalance(e){
			this.state.ETH_CLIENT.eth.getBalance(e, function(error, result){
				if(!error)
					{
					this.setState({addressBalance: +(parseInt(result)/(10**18)).toFixed(6)});
					}
					
				else
					console.log(error)
		
			}.bind(this))

		}

		getEscrowFullInfo(e){
			this.state.entitydb.getEscrowFullInfo(e, function(error, result){
				if(!error)
					{
					this.setState({
						escrowName: result[0],
						escrowInfo: result[1]
					});
					}
				else
					{
						console.log(error)
					}
					
		
			}.bind(this))

			this.state.mee.getEscrowFee(e, function(error, result){
				if(!error)
					{
					this.setState({
						escrowFee: parseInt(result)/10.0
						
					});
					}
				else
					{
						console.log(error)
					}
			}.bind(this))
		}

		resetButtonText(){
			this.setState({
				withdrawText: "Withdraw Funds",
			});
		}


		handleWithdraw(){
			
				this.state.mee.WithdrawFunds({from: this.state.fromAddress, gas: 100000}, function(error, result){
					if(!error)
						this.setState({callback: result,
							popup: true,
							withdrawText: "Withdraw In Progress. Funds will arrive in your address once transaction is mined."});				
					else
						this.setState({withdrawText: "Withdraw Funds"});
						console.log(error)
	
				}.bind(this))
	
		}

	

    handleNameInput(e) {
      this.setState({name: e.target.value});
    }
    handleInfoInput(e) {
      this.setState({info: e.target.value});
    }
  
  
    handleGasInput(e) {
      this.setState({gasLimit: e.target.value});
    }
  
  
    generateTransaction(){
      this.state.entitydb.registerEscrow(this.state.name,this.state.info, {from: this.state.fromAddress, gas: gasLimit}, function(error, result){
				if(!error)
					this.setState({callback: result,
						popup: true});
				else
					
					console.log(error)

			}.bind(this))
    }
  
    setFee(){
      this.state.mee.setEscrowFee(this.state.fee*10, {from: this.state.fromAddress, gas: gasLimit }, function(error, result){
				if(!error)
					this.setState({callback: result,
						popup: true});		
				else
					
					console.log(error)

			}.bind(this))
    }

		
  render() {


	//For dropdown address selection
	var dropdownAddress = []
	
    _.each(this.state.accounts, (value, index) => {
      dropdownAddress.push(
        <option className="dropdownColor" value ={this.state.accounts[index]}>{this.state.accounts[index]}</option>
      )
		})

		var url = ""
		var popup =  (<div></div>)
		if (this.state.popup == true)
			{
				url = "https://ropsten.etherscan.io/tx/" + this.state.callback
				popup = (
					<div className="callback_wrapper">
					<div className="callback">
					<h3>
					Your transaction has been broadcasted to the network. Txhash: <u><a target="_blank" href={url}>{this.state.callback}</a></u>
					</h3>
					</div>
					<div className="callback_right">
					<button className="closeButton" onClick={this.closePopup}>X</button>
					</div>
					</div>
				)
			}

			var escrowProfile = 
			(
				<div className="white-bg padding15">
		<div className="center nodeco">
			<h3>Your Escrow Profile <img className="img-circle" src={this.state.addressBlockie}/></h3>
		<font className="small">{this.state.fromAddress}</font>

		</div>
		
		<p>Escrow Name: {this.state.escrowName}
			<br/>
		
		Escrow Info: {this.state.escrowInfo}
		<br/>
		Fee: {this.state.escrowFee} %
		</p>
		
		
			
			
		
		</div>
		
		
		
		
			)	
	
    return (
    
      
     
  <div className="bg-lb height100">

  <div className="overview_wrapper">
			<br/><br/>
		<div id="container2col2">
		<div id="container2col1">
		<div id="col2-1">
			
	
		<select className="selectbox" onChange={this.handleFromAddressInput} value={this.state.value}>
    <option value="0">Select Address</option>             
		{dropdownAddress}
		</select>	
		<div className="spacer"></div>
		
		
		<div className="white-bg padding15">	
	
		<div className="center nodeco"><h3>Address Balance</h3><h2>{this.state.addressBalance} ETH</h2></div>
		
		</div>
		<div className="spacer"></div>
		

		<div className="white-bg padding15">
		<div className="center"><h3>Contract Balance</h3><h2>{this.state.balance} ETH</h2></div>
		
		<div className="center">
		<button className="smallButton" onClick={this.handleWithdraw}>{this.state.withdrawText}</button>
		
		</div>
		</div>
		<div className="spacer"></div>
		{escrowProfile}
			<div className="spacer"></div>
		
			
		
		<div className="spacer"></div>
		<div className="padding15">
		<NavLink to="/escrow"><button className="smallButton">Back to Escrow Dashboard</button></NavLink>
		</div>
		
		</div>

		
		<div id="col2-2">
		
		<div className="white-bg padding15 minheight">
			
		<h2>Update Escrow Profile</h2>

								<table>
								<tr>
														<td><p className="left">Your Address: {this.state.fromAddress}</p></td>
								</tr>
                          <tr>
                          <td><p className="left">Name:</p></td>
              
                          
                        </tr>
                        <tr>
                          <td><input className="left input-address input-pad" type="text" placeholder="" onChange={this.handleNameInput} value={this.state.name}/></td>
                          
                        </tr>
              
                        <tr>
                          <td><p className="left">Info:</p></td>
                         
                        </tr>
                        <tr>
                          <td><input className="left input-address input-pad" type="text" placeholder="" onChange={this.handleInfoInput} value={this.state.info}/></td>
                        </tr>
								
													
												
								
												 
													<tr>
													<td colSpan="2"><br/><button className="mainButton" onClick={this.generateTransaction}><h2>Update Profile</h2></button><br/><br/></td>
													</tr>
                        </table>
                        
                        <h2>Set Fees</h2>
                        <p>Charge a percentage fee in exchange for your escrow services.<br/>Accepted fee range 0.1% - 10%, in increments of 0.1%</p>
                        <table>
                          <tr>
                          <td><p className="left">Fee (%):</p></td>
                         
                        </tr>
                        <tr>
                          <td><input className="left input-address input-pad" type="text" placeholder="1.5" onChange={this.handleFeeInput} value={this.state.fee}/><br/>
													{this.state.feeInfo}</td>
                        </tr>
											
                        <tr>
													<td colSpan="2"><br/><button className="mainButton" onClick={this.setFee}><h2>Set Fees</h2></button><br/><br/></td>
													</tr>
													</table>
		
		</div>
		
		</div>
	</div>
	</div>
	</div>
	{popup}
  </div>  
      

    )
  }
}

export default RegisterEscrow;



// WEBPACK FOOTER //
// ./src/RegisterEscrow.js